<template>
  <div class="popup text-left">
    <v-slide-y-reverse-transition>
      <v-card
        :class="$vuetify.breakpoint.mdAndUp ? 'rounded-un-popup shaddow-un px-5 pb-5 pt-0' : 'rounded-un-popup shaddow-un px-5 pb-5 pt-0 login-bottom-mobile'"
        width="100%"
        dark
        color="#FF55A6"
        v-if="popup && disponivel"
        :tile="$vuetify.breakpoint.mdAndUp"
      >
        <v-container :class="$vuetify.breakpoint.mdAndUp ? 'pt-0' : 'pt-0 quiz-bottom-mobile'" height="100%">
          <v-row justify="center" align="center">
            <v-col cols="none" md="4"></v-col>
            <v-col cols="12" md="8">
              <div class="text-right">
                <v-icon @click="close()" v-if="popup.quiz_type !== 'textfield'">
                  mdi-close
                </v-icon>
                <v-icon @click="send(true)" v-if="popup.quiz_type === 'textfield'">
                  mdi-close
                </v-icon>
              </div>

              <p v-html="popup.title"></p>

              <v-form v-model="valid" ref="form">
                <div class="text-center">
                  <img :src="popup.image" v-if="popup.image" class="my-3 rounded-un quiz-image" />
                </div>

                <div v-if="popup.description" v-html="popup.description"></div>

                <div v-if="popup.quiz_type === 'select'">
                  <span class="subtitleQuiz"> Apenas uma resposta </span>
                  <v-radio-group v-model="radioAnswer">
                    <v-row>
                      <v-col v-for="(item, i) in popup.answers" :key="i" cols="12" md="6" class="my-0 py-1">
                        <v-radio :value="item.id" color="#FFFFFF" dense hide-details>
                          <template v-slot:label="">
                            <img :src="item.image" v-if="item.image" height="48px" />
                            {{ item.answer }}
                          </template>
                        </v-radio>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                  <v-btn block large color="#FFFFFF" class="mt-2 rounded-un color-pink" @click="send()">Responder</v-btn>
                </div>

                <div v-if="popup.quiz_type === 'buttons'">
                  <v-row class="mt-2">
                    <v-col v-for="(item, i) in popup.answers" :key="i">
                      <v-btn color="white" x-large block :outlined="!item.checked" :class="item.checked ? 'rounded-un color-pink' : 'rounded-un'" @click="send(item.id)">{{ item.answer }}</v-btn>
                    </v-col>
                  </v-row>
                </div>

                <div v-if="popup.quiz_type === 'multiple'">
                  <p class="subtitleQuiz mb-5">Múltiplas respostas</p>
                  <v-row class="mb-5">
                    <v-col :cols="item.image ? '6' : '12'" v-for="(item, i) in popup.answers" :key="i" :class="item.image ? 'text-center' : 'text-left py-0 my-0'">
                      <img :src="item.image" width="100%" v-if="item.image" @click="setAnswer(item.id)" :class="checkSelect(item.id) ? 'multiple-selected rounded-un pa-0' : 'rounded-un pa-0'" />
                      <span v-if="!item.image">
                        <v-checkbox :disabled="checkDisabled(item.id)" v-model="checkbox" :value="item.id" :label="item.answer" hide-details class="my-0" ref="checkbox"></v-checkbox>
                      </span>
                    </v-col>
                  </v-row>

                  <v-btn :disable="popup.max_options && multipleAnswers.length > popup.max_options" block large color="#FFFFFF" class="mt-2 rounded-un color-purple" @click="send()">Responder</v-btn>
                </div>

                <div v-if="popup.quiz_type === 'openfield' || popup.quiz_type === 'checkuserdata'">
                  <div class="quiz-openfield">
                    <div class="quiz-openfield-l">
                      <v-text-field
                        v-if="popup.mask"
                        outlined
                        color="#ffffff"
                        class="input-un-outlined"
                        dark
                        v-model="openfield"
                        v-mask="popup.mask"
                        :rules="[(v) => v.length === 0 || v.length === popup.mask.length || 'Tamanho inválido']"
                      ></v-text-field>
                      <v-text-field v-if="!popup.mask" hide-details outlined color="#ffffff" class="input-un-outlined" dark v-model="openfield"></v-text-field>
                    </div>
                    <div class="quiz-openfield-r">
                      <v-btn block depressed color="#FFFFFF" class="button-un-outlined color-purple" v-mask="popup.mask ? popup.mask : ''" @click="send()">Enviar</v-btn>
                    </div>
                  </div>
                </div>

                <div v-if="popup.quiz_type === 'year'">
                  <div class="quiz-openfield">
                    <div class="quiz-openfield-l">
                      <v-text-field
                        hide-details
                        outlined
                        color="#ffffff"
                        class="input-un-outlined"
                        dark
                        v-model="openfield"
                        v-mask="'####'"
                        placeholder="Ano"
                        label="Ano"
                        type="tel"
                        limit="2050"
                        :rules="openfield ? [(v) => v.length >= 4 || 'Data Inválida'] : []"
                      ></v-text-field>
                    </div>
                    <div class="quiz-openfield-r">
                      <v-btn block depressed color="#FFFFFF" class="button-un-outlined color-purple" @click="send()">Enviar</v-btn>
                    </div>
                  </div>
                </div>

                <div v-if="popup.quiz_type === 'date'">
                  <div class="quiz-openfield">
                    <div class="quiz-openfield-l">
                      <v-text-field
                        hide-details
                        outlined
                        color="#ffffff"
                        class="input-un-outlined"
                        dark
                        v-model="openfield"
                        placeholder="Data"
                        v-mask="'##/##/####'"
                        type="tel"
                        @change="ignoreRule()"
                        :rules="ruleDate"
                      ></v-text-field>
                    </div>
                    <div class="quiz-openfield-r">
                      <v-btn block depressed color="#FFFFFF" class="button-un-outlined color-purple" @click="send()">Enviar</v-btn>
                    </div>
                  </div>
                </div>

                <div v-if="popup.quiz_type === 'cityfield'" class="cityfield">
                  <v-select
                    hide-details
                    outlined
                    background-color="#ffffff"
                    class="mt-2 mb-5 input-un rounded-un"
                    placeholder="Selecione"
                    light
                    :items="states"
                    item-text="nome"
                    item-value="sigla"
                    label="Estado"
                    v-model="state"
                  ></v-select>
                  <v-text-field
                    filled
                    color="#ff55a6"
                    hide-details
                    outlined
                    background-color="#ffffff"
                    class="mt-2 mb-5 input-un rounded-un"
                    placeholder="Cidade"
                    label="Cidade"
                    light
                    v-model="city"
                  ></v-text-field>

                  <v-btn block large color="#FFFFFF" class="mt-2 rounded-un color-pink" @click="send(city + '/' + state)">Responder</v-btn>
                </div>

                <div v-if="popup.quiz_type === 'download'">
                  <v-btn dark color="#7D4CA8" class="rounded-un" block depressed x-large @click="goTo(popup.fileDownload)">
                    <span v-if="popup.button_text">{{ popup.button_text }}</span>
                    <span v-if="!popup.button_text">Download</span>
                  </v-btn>
                </div>

                <div v-if="popup.quiz_type === 'url'">
                  <v-btn dark color="#7D4CA8" class="rounded-un" block depressed x-large @click="goTo(popup.url)">
                    <span v-if="popup.button_text">{{ popup.button_text }}</span>
                    <span v-if="!popup.button_text">Vamos Lá!</span>
                  </v-btn>
                </div>

                <div v-if="popup.quiz_type === 'form'">
                  <div v-for="(item, i) in popup.fields" :key="i">
                    <b class="mt-2">{{ item.title }}</b>

                    <v-text-field
                      filled
                      color="#ff55a6"
                      hide-details
                      outlined
                      dense
                      background-color="#ffffff"
                      class="mt-2 mb-5 input-un rounded-un"
                      light
                      v-mask="item.mask"
                      v-model="answer[item.field_id]"
                      :placeholder="item.title"
                      :label="item.title"
                      :rules="[rules, (v) => (v.length === item.mask.length) | 'Tamanho inválido']"
                      v-if="item.required && item.mask"
                    ></v-text-field>
                    <v-text-field
                      filled
                      color="#ff55a6"
                      hide-details
                      outlined
                      dense
                      background-color="#ffffff"
                      class="mt-2 mb-5 input-un rounded-un"
                      light
                      v-model="answer[item.field_id]"
                      :placeholder="item.title"
                      :label="item.title"
                      :rules="rules"
                      v-if="item.required && !item.mask"
                    ></v-text-field>
                    <v-text-field
                      filled
                      color="#ff55a6"
                      hide-details
                      outlined
                      dense
                      background-color="#ffffff"
                      class="mt-2 mb-5 input-un rounded-un"
                      v-mask="item.mask"
                      :placeholder="item.title"
                      :label="item.title"
                      :rules="[(v) => (v.length === item.mask.length) | 'Tamanho inválido']"
                      light
                      v-model="answer[item.field_id]"
                      v-if="!item.required && item.mask"
                      style="border:1px solid red !important;"
                    ></v-text-field>
                    <v-text-field
                      filled
                      color="#ff55a6"
                      hide-details
                      outlined
                      dense
                      background-color="#ffffff"
                      class="mt-2 mb-5 input-un rounded-un"
                      :placeholder="item.title"
                      :label="item.title"
                      light
                      v-model="answer[item.field_id]"
                      v-if="!item.required && !item.mask"
                    ></v-text-field>
                  </div>

                  <v-btn dark color="#7D4CA8" class="rounded-un mt-2" block depressed large @click="send()">
                    <span v-if="popup.button_text">{{ popup.button_text }}</span>
                    <span v-if="!popup.button_text">Enviar</span>
                  </v-btn>
                </div>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-slide-y-reverse-transition>
  </div>
</template>

<script>
import axios from 'axios'
import { mask } from 'vue-the-mask'
import { mapState } from 'vuex'
import { baseApiUrl } from '@/global'

export default {
  directives: { mask },
  computed: {
    ...mapState(['popup', 'error', 'journeyDialog', 'sequence']),
    route() {
      return this.$route.path
    },
  },
  watch: {
    popup() {
      if (this.popup && this.popup.quiz_type) {
        if ((this.popup.quiz_type === 'openfield' || this.popup.quiz_type === 'year' || this.popup.quiz_type === 'checkuserdata') && this.popup.answers) {
          this.openfield = this.popup.answers
        }
        if (this.popup.quiz_type === 'select' && this.popup.answers) {
          for (let i = 0; i < this.popup.answers.length; i++) {
            const element = this.popup.answers[i]
            if (element.checked) {
              this.radioAnswer = element.id
            }
          }
        }
        if (this.popup.quiz_type === 'date' && this.popup.answers) {
          const newBirth = this.popup.answers.split('-')
          this.openfield = newBirth[2] + '/' + newBirth[1] + '/' + newBirth[0]
        }
        if (this.popup.quiz_type === 'cityfield' && this.popup.answers) {
          const ans = this.popup.answers.split('/')
          this.city = ans[0]
          this.state = ans[1]
        }
        if (this.popup.quiz_type === 'multiple') {
          const resp = this.popup.answers
          for (const ans of resp) {
            if (ans.checked) {
              this.checkbox.push(ans.id)
            }
          }
        }
      }
    },
    error() {
      this.checkAvailable()
    },
    journeyDialog() {
      this.checkAvailable()
    },
    route() {
      this.checkAvailable()
    },
  },
  data: () => ({
    ruleDate: [],
    valid: false,
    radioGroup: 1,
    multipleAnswers: [],
    radioAnswer: null,
    openfield: null,
    answer: {},
    checkbox: [],
    disponivel: true,
    states: [
      { nome: 'Acre', sigla: 'AC' },
      { nome: 'Alagoas', sigla: 'AL' },
      { nome: 'Amapá', sigla: 'AP' },
      { nome: 'Amazonas', sigla: 'AM' },
      { nome: 'Bahia', sigla: 'BA' },
      { nome: 'Ceará', sigla: 'CE' },
      { nome: 'Distrito Federal', sigla: 'DF' },
      { nome: 'Espírito Santo', sigla: 'ES' },
      { nome: 'Goiás', sigla: 'GO' },
      { nome: 'Maranhão', sigla: 'MA' },
      { nome: 'Mato Grosso', sigla: 'MT' },
      { nome: 'Mato Grosso do Sul', sigla: 'MS' },
      { nome: 'Minas Gerais', sigla: 'MG' },
      { nome: 'Pará', sigla: 'PA' },
      { nome: 'Paraíba', sigla: 'PB' },
      { nome: 'Paraná', sigla: 'PR' },
      { nome: 'Pernambuco', sigla: 'PE' },
      { nome: 'Piauí', sigla: 'PI' },
      { nome: 'Rio de Janeiro', sigla: 'RJ' },
      { nome: 'Rio Grande do Norte', sigla: 'RN' },
      { nome: 'Rio Grande do Sul', sigla: 'RS' },
      { nome: 'Rondônia', sigla: 'RO' },
      { nome: 'Roraima', sigla: 'RR' },
      { nome: 'Santa Catarina', sigla: 'SC' },
      { nome: 'São Paulo', sigla: 'SP' },
      { nome: 'Sergipe', sigla: 'SE' },
      { nome: 'Tocantins', sigla: 'TO' },
    ],
    state: null,
    city: null,
    limit: 2,
    actual: 0,
    updated: false,
  }),
  methods: {
    reset() {
      this.valid = false
      this.radioGroup = 1
      this.multipleAnswers = []
      this.radioAnswer = null
      this.openfield = null
      this.answer = {}
      this.checkbox = []
      this.state = null
      this.city = null
      this.$store.dispatch('setSequenceInfo', true)
    },
    close() {
      if (this.popup && this.popup.quiz_type !== 'textfield' && !this.popup.ignore) {
        this.$store.dispatch('setTutorialInfo', {
          open: true,
          step: 1,
        })
      }
      this.radioGroup = 1
      this.multipleAnswers = []
      this.radioAnswer = null
      this.openfield = null
      this.answer = {}
      this.checkbox = []
      this.state = null
      this.city = null

      this.$store.dispatch('setPopupInfo', null)
      this.$store.dispatch('setSequenceInfo', false)
    },
    clear() {
      this.radioGroup = 1
      this.multipleAnswers = []
      this.radioAnswer = null
      this.openfield = null
      this.answer = {}
      this.checkbox = []
      this.state = null
      this.city = null
      this.$store.dispatch('setPopupInfo', null)
    },
    send(value = null) {
      if (this.popup && this.popup.ignore) {
        this.close()
        return
      }

      this.$refs.form.validate()

      if (!this.valid && (this.popup.quiz_type === 'form' || this.popup.quiz_type === 'openfield' || this.popup.quiz_type === 'date' || this.popup.quiz_type === 'year')) {
        this.$store.dispatch('setErrorInfo', {
          open: true,
          text: 'Ops, temos algum probleminha. Cheque os campos pra ver se tudo foi preenchido corretamente.',
        })
        return
      }
      localStorage.removeItem('reactPost')

      const qs = require('qs')
      const url = `${baseApiUrl}/answer`
      const object = {
        quiz_id: this.popup.id,
      }
      if (this.popup.action_id) {
        object.action_id = this.popup.action_id
      }
      if (this.popup.quiz_type === 'select') {
        object.answer = this.radioAnswer
      }
      if (this.popup.quiz_type === 'multiple') {
        object.answer = this.checkbox
      }
      if (this.popup.quiz_type === 'openfield' || this.popup.quiz_type === 'date' || this.popup.quiz_type === 'year' || this.popup.quiz_type === 'checkuserdata') {
        object.answer = this.openfield
        if (this.popup.quiz_type === 'date') {
          const newBirth = this.openfield.split('/')
          object.answer = newBirth[2] + '-' + newBirth[1] + '-' + newBirth[0]
        }
      }
      if (this.popup.quiz_type === 'form') {
        object.answer = []
        Object.keys(this.answer).forEach((key) => {
          object.answer[key] = this.answer[key]
        })
      }
      if (value) {
        object.answer = value
      }
      this.clear()
      axios.post(url, qs.stringify(object)).then((res) => {
        if (res.data.quiz) {
          this.$store.dispatch('setPopupInfo', res.data.quiz)
        } else {
          this.$store.dispatch('setSequenceInfo', false)
          // this.loadJourney();
        }
      })
    },
    setAnswer(item, event = null) {
      if (event) {
        event.preventDefault()
      }

      let has = this.checkSelect(item)
      if (has === true) {
        this.checkbox[item] = false
        this.multipleAnswers.pop(item)
      } else {
        if (this.popup.max_options) {
          if (this.multipleAnswers.length < this.popup.max_options) {
            this.checkbox[item] = true
            this.multipleAnswers.push(item)
          } else {
            this.checkbox[item] = false
          }
        } else {
          this.checkbox[item] = true
          this.multipleAnswers.push(item)
        }
      }
    },
    checkSelect(item) {
      let has = false
      for (let i = 0; i < this.multipleAnswers.length; i++) {
        const element = this.multipleAnswers[i]
        if (item === element) {
          has = true
        }
      }
      return has
    },
    goTo(link) {
      const qs = require('qs')
      const url = `${baseApiUrl}/answer`
      const object = {
        quiz_id: this.popup.id,
        answer: true,
        action_id: this.id,
      }

      window.open(link, '_blank')
      this.clear()
      axios.post(url, qs.stringify(object)).then((res) => {
        if (res.data.quiz) {
          this.$store.dispatch('setPopupInfo', res.data.quiz)
        }else {
          this.$store.dispatch('setSequenceInfo', false)
        }
      })
    },
    loadJourney() {
      const url = `${baseApiUrl}/journey`
      axios
        .get(url)
        .then((res) => {
          this.journey = res.data.journey
          const rawJourney = localStorage.getItem('journey')

          let journeyOld = null
          if (rawJourney) {
            journeyOld = JSON.parse(rawJourney)

            if (journeyOld.etapa !== this.journey.etapa) {
              // alert('mudança de jornada')
              this.$store.dispatch('setJourneyDialogInfo', { open: true })
              localStorage.setItem('journey', JSON.stringify(this.journey))
            }
          } else {
            // alert('nova jornada')
            this.$store.dispatch('setJourneyDialogInfo', { open: true })
          }
          localStorage.setItem('journey', JSON.stringify(this.journey))
          this.$store.dispatch('setJourneyInfo', this.journey)
        })
        .catch((err) => {
          if (!err.response.status === 403) {
            this.$store.dispatch('setErrorInfo', {
              open: true,
              text: 'Ops! Parece que algo deu errado. :( Talvez tenha sido um erro no link, ou alguma instabilidade no site (se for isso, já estamos resolvendo). ;) ',
            })
          }
        })
    },
    checkDisabled(id) {
      if (!this.popup.max_options) {
        return false
      }
      if (this.checkbox.includes(id)) {
        return false
      }
      if (this.checkbox.length >= this.popup.max_options) {
        return true
      }
      return false
    },
    checkAvailable() {
      if (!this.error && !this.journeyDialog && this.$route.path !== '/jornada' && this.$route.path.split('/')[1] !== 'recompensa' && this.$route.path.split('/')[1] !== 'bonus') {
        this.disponivel = true
      } else {
        this.disponivel = false
      }
    },
    ignoreRule() {
      if (this.openfield === '' || !this.openfield) {
        this.ruleDate = []
      } else {
        this.ruleDate = [(v) => /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/.test(v) || 'Data Inválida']
      }
    },
  },
  mounted() {},
}
</script>

<style>
.popup {
  position: fixed;
  left: 0;
  bottom: 0px;
  width: 100% !important;
  z-index: 30;
  font-family: 'DM Sans' !important;
}

.quiz-image {
  max-height: 20vh;
  width: auto;
  max-width: 100%;
}

.quiz-popup a,
.quiz-popup a:visited {
  color: #ffffff !important;
  text-decoration: none;
}

.quiz-popup a:hover {
  color: #ffffff !important;
}

.rounded-un-popup {
  border-radius: 15px 15px 0 0 !important;
}
.subtitleQuiz {
  color: #eeeeee !important;
  font-family: 'DM Sans' !important;
  font-size: 14px !important;
  font-weight: bold !important;
}
.multiple-selected {
  border-radius: 15px !important;
  border: 1px solid white;
  font-weight: bolder;
}

.quiz-openfield {
  height: 56px !important;
  display: flex;
}

.input-un-outlined {
  border-radius: 15px 0 0 15px !important;
  height: 100% !important;
  margin: 0 !important;
}

.button-un-outlined {
  border-radius: 0 15px 15px 0 !important;
  height: 100% !important;
  margin: 0 !important;
}

.quiz-openfield-l {
  width: 70%;
  height: 100% !important;
  display: inline-block;
  margin: 0 !important;
}
.quiz-openfield-r {
  width: 30%;
  height: 100% !important;
  display: inline-block;
  margin: 0 !important;
}

.quiz-bottom-mobile {
  padding-bottom: 80px;
}
</style>
